import { create } from "zustand";
import { httpService } from "../../../../../base/services/httpService.service";

export const requestStore = create((set) => ({
   activeTab: "1",
   activeNestedTab: "pending",
   filters: { name: "", email: "" },
   pagination: { pageNumber: 1, pageSize: 10 },
   requestStatistics: {},
   currentPage: 1,

   // Loading requests states
   isLoadingPending: false,
   isLoadingApproved: false,
   isLoadingRejected: false,
   isApproveSingleRequestLoading: false,
   rejectSingleRequestLoading: false,
   approveAllLoading: false,
   rejectAllLoading: false,
   isPopupLoading: true,

   setIsLoadingPending: (payload) => {
      set({
         isLoadingPending: payload
      });
   },

   setIsLoadingApproved: (payload) => {
      set({
         isLoadingApproved: payload
      });
   },

   setIsLoadingRejected: (payload) => {
      set({
         isLoadingRejected: payload
      });
   },

   setIsApproveSingleRequestLoading: (payload) => {
      set({
         isApproveSingleRequestLoading: payload
      });
   },
   setRejectSingleRequestLoading: (payload) => {
      set({
         rejectSingleRequestLoading: payload
      });
   },
   setApproveAllLoading: (payload) => {
      set({
         approveAllLoading: payload
      });
   },
   setRejectAllLoading: (payload) => {
      set({
         rejectAllLoading: payload
      });
   },
   setIsPopupLoading: (payload) => {
      set({
         isPopupLoading: payload
      });
   },

   setCurrentPage: (page) => {
      set({ currentPage: page });
   },

   // name: "",
   // email: "",
   setPagination: (payload) => {
      set({
         pagination: payload
      });
   },

   setActiveTab: (item) => {
      set({
         activeTab: item
      });
   },

   setActiveNestedTab: (payload) => {
      set({
         activeNestedTab: payload
      });
   },

   setFilters: (payload) => {
      set({
         filters: payload
      });
   },
   setRequestStatistics: () => {
      httpService.get("/Request/guided/request", (res) => {
         set({ requestStatistics: res?.data });
      });
   },
   // setName: (payload) => {
   //    set({
   //       name: payload
   //    });
   // },
   // setEmail: (payload) => {
   //    set({
   //       email: payload
   //    });
   // },

   //    request data
   pendingRequests: [],
   approvedRequests: [],
   rejectedRequests: [],
   pendingRequestsSize: { totalItemCount: 0 },
   approvedRequestsSize: { totalItemCount: 0 },
   rejectedRequestsSize: { totalItemCount: 0 },

   setPendingRequests: (payload) => {
      set({
         pendingRequests: payload
      });
   },

   setApprovedRequests: (payload) => {
      set({
         approvedRequests: payload
      });
   },

   setRejectedRequests: (payload) => {
      set({
         rejectedRequests: payload
      });
   },
   setPendingRequestsSize: (payload) => {
      set({
         pendingRequestsSize: payload
      });
   },
   setApprovedRequestsSize: (payload) => {
      set({
         approvedRequestsSize: payload
      });
   },
   setRejectedRequestsSize: (payload) => {
      set({
         rejectedRequestsSize: payload
      });
   }
}));
